import React from 'react';
import headerBg from '../assets/images/headerBg.jpeg';
import microsoft from '../assets/images/microsoftLogo.png';
import foundation from '../assets/images/foundationLogo.png';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import CallMadeIcon from '@mui/icons-material/CallMade';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';

function Header() {
  return (
    <div
      className='h-[auto] w-full bg-no-repeat object-cover '
      style={{
        backgroundImage: `url(${headerBg})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
      }}
    >
      <div className='w-full h-full bg-[rgba(7,26,69,0.9)] flex flex-wrap justify-center items-center md:py-[36px]  '>
        <div
          className='w-[564px] h-[auto] py-[20px] text-[#232323] bg-[#071a45] text-[16px] leading-[24px] tracking-[normal] text-start '
          data-aos='zoom-in-down'
        >
          <h1 className='text-[64px] leading-[70.4px] text-left text-[#ffffff] tracking-[normal] py-[18px] px-[8px]'>
            Digital Skills for the future of work.
          </h1>
          <p className='text-[19.2px] leading-[28.8px] mt-2 text-start tracking-[normal] text-[#ffffff] px-[8px] mb-[47px]'>
            In its mission to develop Africa's next generation of digital
            talents, Wootlab Foundation has partnered with Microsoft to provide
            a well-structured virtual learning platform and internationally
            recognised certificates for FREE in an effort to close the
            knowledge, skills, and technology gaps that exist in most of our
            communities.
          </p>
          <div className='flex justify-center items-center flex-col h-auto w-auto gap-[25px]'>
            <p className='text-white'>
              Registration for Digital Skills Nigeria FREE training now on.
            </p>
            <a
              className='flex items-center justify-center rounded-[30px] w-[auto] h-[54px]  text-[13.6px] leading-[26.4px] text-center tracking-[normal] shadow-md 
                text-[white] mx-[19px] hover:bg-[rgb(251,189,57)] hover:rounded-[50px] hover:scale-[2px] hover:text-white hover:border-collapse hover:-translate-y-[7px] animate-bounce hover:cursor-pointer p-[12px] bg-[rgb(251,189,57)] border-collapse border-none'
              href='https://wootlab.ng/foundation/dsn'
            >
              Click here to register!
            </a>
          </div>
        </div>
        <div
          className=' w-[656px] h-[420px] pt-[16px] pb-[16px]'
          data-aos='zoom-in-up'
        >
          <img
            src={headerBg}
            alt='header missing'
            className='h-[700] w-[1172px]'
          />
        </div>
        <div
          className='w-full h-auto flex flex-wrap justify-center items-center '
          data-aos='zoom-in-up'
        >
          <div className='w-full flex-wrap md:w-[1280px] h-[auto] flex md:flex-no-wrap justify-center items-center py-[30px] gap-[40px]'>
            <div className='w-[285px]  h-auto py-[15px] px-[15px] leading-[24px] rounded-[4px]'>
              <img
                src={foundation}
                alt='header missing'
                className='h-[100px] w-[300px] mx-[-16px] my-[8px]'
              />
            </div>
            <div className='w-[285px] py-[15px] px-[15px] leading-[24px] rounded-[4px]'>
              <img
                src={microsoft}
                alt='header missing'
                className='h-[101px] w-[300px] mx-[-16px] my-[8px]'
              />
            </div>
          </div>
        </div>
        {/*  */}
        <div className='w-full h-auto  md:bg-[#ffffff]  md:h-[207px] flex justify-center items-center mb-[20px] pt-[15px] text-[16px] leading-[24px] text-start tracking-[normal]'>
          <div className='h-auto w-full md:w-[1140px] md:h-[166px] px-[16px] mx-[70px]  flex justify-center items-center leading-[24px] flex-wrap'>
            <div className='w-[369px] h-[137px] px-[16px] py-[16px] bg-white flex justify-center items-center'>
              <div
                className='w-[80px] h-[auto] mr-[32px] ml-[8px] mb-[16px] leading-[24px]'
                data-aos='zoom-in-left'
              >
                <p className='leading-[14px] text-center tracking-[normal] py-[8px] px-[2px]'>
                  {' '}
                  <CallMadeIcon sx={{ fontSize: 100 }} />
                </p>
              </div>
              <div
                className='w-[auto] h-[89px] mr-[32px] ml-[3px] mb-[16px] leading-[24px]'
                data-aos='zoom-in-right'
              >
                <h1 className='text-[19.2px] w-[217px] h-[28px] leading-[28.8px] text-start tracking-[normal]  text-[#041a45] mb-[8px] font-bold'>
                  {' '}
                  Upskill and Reskill
                </h1>
                <p className='w-[217px] h-[52px] text-[#767676] text-[17.6px] leading-[26.4px] text-start mb-[16px]'>
                  Free online courses to build the skills
                </p>
              </div>
            </div>
            {/*  */}
            <div className='w-[369px] h-[137px] px-[16px] py-[16px]  bg-white flex justify-center items-center'>
              <div
                className='w-[80px] h-[auto] mr-[32px] ml-[8px] mb-[16px] leading-[24px]'
                data-aos='zoom-in-left'
              >
                <p className='leading-[14px] text-center tracking-[normal] py-[8px] px-[2px]'>
                  {' '}
                  <WorkspacePremiumIcon sx={{ fontSize: 100 }} />
                </p>
              </div>

              <div
                className='w-[auto] h-[89px] mr-[32px] ml-[8px] mb-[16px] leading-[24px]'
                data-aos='zoom-in-right'
              >
                <h1 className='text-[19.2px] w-[217px] h-[28px] leading-[28.8px] text-start tracking-[normal]  text-[#041a45] mb-[8px] font-bold'>
                  {' '}
                  Acquire certifications
                </h1>
                <p className='w-[217px] h-[52px] text-[#767676] text-[17.6px] leading-[26.4px] text-start mb-[16px]'>
                  Globally recognized certifications
                </p>
              </div>
            </div>
            {/*  */}
            <div className='w-[369px] h-[137px] px-[16px] py-[16px]  bg-white flex justify-center items-center'>
              <div
                className='w-[80px] h-[auto] mr-[32px] ml-[8px] mb-[16px] leading-[24px]'
                data-aos='zoom-in-left'
              >
                <p className='leading-[14px] text-center tracking-[normal] py-[8px] px-[2px]'>
                  {' '}
                  <PersonSearchIcon sx={{ fontSize: 100 }} />
                </p>
              </div>
              <div
                className='w-[auto] h-[89px] mr-[32px] ml-[8px] mb-[16px] leading-[24px]'
                data-aos='zoom-in-right'
              >
                <h1 className='text-[19.2px] w-[auto] h-[28px] leading-[28.8px] text-start tracking-[normal]  text-[#041a45] mb-[25px] font-bold'>
                  {' '}
                  Skills based employment
                </h1>
                <p className='w-[217px] h-[52px] text-[#767676] text-[17.6px] leading-[26.4px] text-start mb-[16px]'>
                  Explore resources to help you find just the right role.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/*  */}
        <div
          className='w-full h-auto md:w-[1148px] md:h-[28px] px-[34px] my-[20px] mx-[50px] text-[19.2px] leading-[28.8px] text-start text-white'
          data-aos='zoom-out'
        >
          Anytime, anywhere learning!
        </div>
      </div>
    </div>
  );
}
export default Header;
